import {Route, Routes} from 'react-router-dom';

import {AppHeader} from '../components/AppHeaders/AppHeader';
import {ErrorMessage} from '../components/ErrorMessage/ErrorMessage';
import {PageContainer} from '../components/PageContainer/PageContainer';
import ApplicantDashboard from '../features/applicant/dashboard/components/ApplicantDashboard';
import {ApplicantCulturePage} from '../pages/applicant/culture/ApplicantCulturePage';
import {ApplicantMatchDetailsPage} from '../pages/applicant/matches/ApplicantMatchDetailsPage';
import ApplicantOnboardingPage from '../pages/applicant/onboarding/ApplicantOnboardingPage';
import ApplicantProfilePage from '../pages/applicant/profile/ApplicantProfilePage';

import {ApplicantGuard} from './RouteGuards/ApplicantGuard';
import {ApplicantOnboardingCompletedGuard} from './RouteGuards/ApplicantOnboardingCompletedGuard';

export const ApplicantRoutes = () => {
  return (
    <>
      <PageContainer>
        <AppHeader type='applicant' />
        <Routes>
          <Route path='/*' element={<ApplicantGuard />}>
            <Route path='onboarding' element={<ApplicantOnboardingPage />} />
            <Route element={<ApplicantOnboardingCompletedGuard />}>
              <Route path='dashboard' element={<ApplicantDashboard />} />
              <Route path='profile' element={<ApplicantProfilePage />} />
              <Route path='culture' element={<ApplicantCulturePage />} />
              <Route path='matches/:id' element={<ApplicantMatchDetailsPage />} />
            </Route>
            <Route path='*' element={<ErrorMessage isOutOfBounds />} />
          </Route>
        </Routes>
      </PageContainer>
    </>
  );
};
